import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { Loader2 } from "lucide-react"

export type DeactivateIntegrationSecretDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  secretName: string
  maskedTail: string
  onConfirm: () => void | Promise<void>
  isProcessing?: boolean
}

export function DeactivateIntegrationSecretDialog({
  open,
  onOpenChange,
  secretName,
  maskedTail,
  onConfirm,
  isProcessing,
}: DeactivateIntegrationSecretDialogProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (isProcessing) return
        onOpenChange(nextOpen)
      }}
    >
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Deactivate secret?</DialogTitle>
          <DialogDescription className="space-y-2 text-left">
            This will permanently deactivate{" "}
            <span className="font-medium text-foreground">{secretName}</span>
            {maskedTail ? (
              <>
                {" "}
                (<span className="font-mono">{maskedTail}</span>)
              </>
            ) : null}
            . It will stop working for OAuth immediately. Deactivated secrets stay in the list
            for audit.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-0">
          <Button
            type="button"
            variant="outline"
            disabled={isProcessing}
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
          <Button
            type="button"
            variant="destructive"
            disabled={isProcessing}
            onClick={() => void onConfirm()}
          >
            {isProcessing ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" aria-hidden />
                Deactivating…
              </>
            ) : (
              "Deactivate secret"
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
